import { gql } from "lib/apolloClient";

export const assignProjectToSupervisorMutation = gql`
  mutation assignProjectToSupervisor(
    $projectId: ID!
    $addedArray: [ID!]
    $removedArray: [ID!]
  ) {
    documentation {
      assignProjectToSupervisor(
        input: {
          projectId: $projectId
          staff: { added: $addedArray, removed: $removedArray }
        }
      )
    }
  }
`;

export const assignSupervisorToProjectMutation = gql`
  mutation assignSupervisorToProject(
    $staffId: ID
    $addedArray: [ID!]
    $removedArray: [ID!]
    $projectsToUpdate: [ID!]
    $staffIds: [ID!]
  ) {
    documentation {
      assignSupervisorToProject(
        input: {
          staffId: $staffId
          project: { added: $addedArray, removed: $removedArray }
          projectsToUpdate: $projectsToUpdate
          staffIds: $staffIds
        }
      )
    }
  }
`;

export const portfolioUpdateStudentsAllocationForSupervisorMutation = gql`
  mutation portfolioUpdateStudentsAllocationForSupervisor(
    $projectGroupId: ID!
    $staffId: ID!
    $addedStudents: [ID!]
    $removedStudents: [ID!]
  ) {
    documentation {
      portfolioUpdateStudentsAllocationForSupervisor(
        input: {
          projectGroupId: $projectGroupId
          staffId: $staffId
          addedStudents: $addedStudents
          removedStudents: $removedStudents
        }
      )
    }
  }
`;
export const portfolioUpdateSupervisorAllocationForStudentMutation = gql`
  mutation portfolioUpdateSupervisorAllocationForStudent(
    $projectGroupId: ID!
    $staffId: ID
    $studentId: ID!
  ) {
    documentation {
      portfolioUpdateSupervisorAllocationForStudent(
        input: {
          projectGroupId: $projectGroupId
          staffId: $staffId
          studentId: $studentId
        }
      )
    }
  }
`;

export const inviteProjectGroupSupervisorMutation = gql`
  mutation inviteProjectGroupSupervisor(
    $projectGroupId: ID!
    $addedArray: [ID!]
    $removedArray: [ID!]
  ) {
    documentation {
      inviteProjectGroupSupervisors(
        input: {
          projectGroupId: $projectGroupId
          staff: { added: $addedArray, removed: $removedArray }
        }
      )
    }
  }
`;

export const inviteProjectStudentMutation = gql`
  mutation intiveProjectStudent(
    $projectGroupId: ID!
    $studentIdsToInvite: [ID!]
    $projectIdsToRemove: [ID!]
  ) {
    documentation {
      inviteProjectStudents(
        input: {
          projectGroupId: $projectGroupId
          studentIdsToInvite: $studentIdsToInvite
          projectIdsToRemove: $projectIdsToRemove
        }
      )
    }
  }
`;

export const inviteProjectGroupStudentsMutation = gql`
  mutation inviteProjectGroupStudents(
    $projectGroupId: ID!
    $addArray: [ID!]
    $removeArray: [ID!]
  ) {
    documentation {
      inviteProjectGroupStudents(
        input: {
          projectGroupId: $projectGroupId
          student: { added: $addArray, removed: $removeArray }
        }
      )
    }
  }
`;

export const updateProjectGroupSupervisorApprovalStatusMutation = gql`
  mutation updateProjectGroupSupervisorApprovalStatus(
    $id: ID!
    $approvalStatus: PROJECT_GROUP_SUPERVISOR_APPROVAL_STATUS_ENUM!
    $supervisorIds: [ID!]!
  ) {
    documentation {
      updateProjectGroupSupervisorApprovalStatus(
        input: {
          projectGroupId: $id
          approvalStatus: $approvalStatus
          supervisorIds: $supervisorIds
        }
      ) {
        isSuccess
        warning
      }
    }
  }
`;
